/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RabatKampagneDto as OkEgisServiceModelsDtoRabatKampagneDto } from '../models/OK/Egis/Service/Models/DTO/rabat-kampagne-dto';
import { CreateRabatKampagneDto as OkEgisServiceModelsRequestCreateRabatKampagneDto } from '../models/OK/Egis/Service/Models/Request/create-rabat-kampagne-dto';

@Injectable({
  providedIn: 'root',
})
export class RabatKampagneService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRabatKampagner
   */
  static readonly GetRabatKampagnerPath = '/api/v1/RabatKampagne/GetRabatKampagner';

  /**
   * Returns a list of rabatkampagner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRabatKampagner()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRabatKampagner$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoRabatKampagneDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RabatKampagneService.GetRabatKampagnerPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoRabatKampagneDto>>;
      })
    );
  }

  /**
   * Returns a list of rabatkampagner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRabatKampagner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRabatKampagner(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoRabatKampagneDto>> {

    return this.getRabatKampagner$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoRabatKampagneDto>>) => r.body as Array<OkEgisServiceModelsDtoRabatKampagneDto>)
    );
  }

  /**
   * Path part for operation getActiveRabatKampagner
   */
  static readonly GetActiveRabatKampagnerPath = '/api/v1/RabatKampagne/GetActiveRabatKampagner';

  /**
   * Returns a list of rabatkampagner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveRabatKampagner()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveRabatKampagner$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoRabatKampagneDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RabatKampagneService.GetActiveRabatKampagnerPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoRabatKampagneDto>>;
      })
    );
  }

  /**
   * Returns a list of rabatkampagner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getActiveRabatKampagner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveRabatKampagner(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoRabatKampagneDto>> {

    return this.getActiveRabatKampagner$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoRabatKampagneDto>>) => r.body as Array<OkEgisServiceModelsDtoRabatKampagneDto>)
    );
  }

  /**
   * Path part for operation createRabatkampagne
   */
  static readonly CreateRabatkampagnePath = '/api/v1/RabatKampagne';

  /**
   * Creates a rabatkampagne.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRabatkampagne()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRabatkampagne$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateRabatKampagneDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoRabatKampagneDto>> {

    const rb = new RequestBuilder(this.rootUrl, RabatKampagneService.CreateRabatkampagnePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoRabatKampagneDto>;
      })
    );
  }

  /**
   * Creates a rabatkampagne.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createRabatkampagne$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRabatkampagne(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateRabatKampagneDto
  }): Observable<OkEgisServiceModelsDtoRabatKampagneDto> {

    return this.createRabatkampagne$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoRabatKampagneDto>) => r.body as OkEgisServiceModelsDtoRabatKampagneDto)
    );
  }

  /**
   * Path part for operation updateRabatKampagne
   */
  static readonly UpdateRabatKampagnePath = '/api/v1/RabatKampagne/{rabatKampagneId}';

  /**
   * Updates a rabatkampagne.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRabatKampagne()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRabatKampagne$Response(params: {
    rabatKampagneId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateRabatKampagneDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoRabatKampagneDto>> {

    const rb = new RequestBuilder(this.rootUrl, RabatKampagneService.UpdateRabatKampagnePath, 'put');
    if (params) {
      rb.path('rabatKampagneId', params.rabatKampagneId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoRabatKampagneDto>;
      })
    );
  }

  /**
   * Updates a rabatkampagne.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateRabatKampagne$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRabatKampagne(params: {
    rabatKampagneId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateRabatKampagneDto
  }): Observable<OkEgisServiceModelsDtoRabatKampagneDto> {

    return this.updateRabatKampagne$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoRabatKampagneDto>) => r.body as OkEgisServiceModelsDtoRabatKampagneDto)
    );
  }

}
